import { ChevronsUpDown } from 'lucide-react';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandList,
} from 'components/shadcn/command';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'components/shadcn/popover';
import { Button, FormControl } from 'components/shadcn';
import { useEffect, useState } from 'react';
import { cn } from './lib';

export function Combobox({
  id,
  placeholder,
  value,
  options,
  renderOptions,
  closeOnSelect = true,
  disabled = false,
  'aria-invalid': ariaInvalid,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (closeOnSelect) {
      setOpen(false);
    }
  }, [value]);

  return (
    <Popover
      open={disabled ? false : open}
      onOpenChange={disabled ? undefined : setOpen}
    >
      <PopoverTrigger asChild>
        <FormControl>
          <Button
            id={id}
            variant="outline"
            role="combobox"
            type="button"
            aria-expanded={open}
            disabled={disabled}
            className={cn(
              'justify-between font-normal w-full',
              placeholder && !value ? 'text-muted-foreground' : '',
              ariaInvalid === 'true' &&
                'border-destructive ring-destructive/20 dark:ring-destructive/40',
            )}
          >
            {value ? value : placeholder}
            <ChevronsUpDown className="opacity-50" />
          </Button>
        </FormControl>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Command>
          <CommandInput placeholder="Search ..." className="h-9" />
          <CommandList>
            <CommandEmpty>No options.</CommandEmpty>
            <CommandGroup>{options.map(renderOptions)}</CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
